<template>
  <div class="button" :class="{'button-active':touchState}" @touchstart="handleTouchstart" @touchend="handleTouchend($event)">
    <span class="button-text">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  data(){
    return {
      touchState:false
    }
  },
  methods:{
    handleTouchstart(){
      this.touchState = true;
    },
    handleTouchend(e){
      this.$emit('click',e);
      setTimeout(() => {
        this.touchState = false;
      }, 100);
    }
  }
}
</script>

<style scoped lang="scss">
  .button,
  .button-active {
    font-size: 16px;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    border-style: solid;
    border-width: 1px;
    border-radius: 8px;
    display: inline-block;
    margin: 0 10px 10px 0;
  }
  .button {
    color: #130A01;
    border-color: #E3E3E3;
  }
  .button-active {
    color: #F1892E;
    border-color: #F1892E;
  }
</style>